/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { membershipBulkOperationSchema } from './membershipBulkOperationSchema';

export const bulkTeamActionRequestSchema = z.object({
  get membershipsToAdd() {
    return z.union([membershipBulkOperationSchema, z.null()]).optional();
  },
  get membershipsToRemove() {
    return z.union([membershipBulkOperationSchema, z.null()]).optional();
  },
});
